import { appActions } from '@/core/state/app'

/**
 * The one seam between a command and the Monte Carlo composable.
 *
 * `runMonteCarlo` is 480 lines that fetch config, poll progress and write eight
 * Vue refs; a command must be able to start a run without importing any of
 * that, exactly as `mapBridge` lets a command redraw the map without importing
 * Leaflet. The composable registers itself when MapView mounts; the command
 * asks. When the simulation itself becomes framework-agnostic this file is what
 * gets deleted.
 */
type SimulationRunner = () => void | Promise<void>

let runner: SimulationRunner | null = null

/** Called by `useMonteCarloHandlers` when the island mounts, and with null when it goes. */
export function registerSimulationRunner(next: SimulationRunner | null) {
  runner = next
}

/**
 * Start a run, if anything is listening.
 *
 * Returns false and says so when nothing is: a silent no-op is
 * indistinguishable from a simulation that ran and found nothing, and that
 * failure mode has cost this codebase five defects already.
 */
export async function requestSimulationRun(): Promise<boolean> {
  if (!runner) {
    appActions.showSnackbar('The map is still loading — try again in a moment.', 'warning')
    return false
  }
  await runner()
  return true
}

/** Tests only. */
export function __resetSimulationBridge() {
  runner = null
}
